/* CUSTOM_ORDERMAILINBOX_BY_CLAUDE (AIOPS 8b81a4020e49, 2026-09-08) — THE orders@ INBOX, IN THE PORTAL.
   Admin-only toolbar pill + modal over the worker's Inbox routes:
     GET  /order-mail/inbox?folder=&from=&subjectContains=&since=&limit=   list / search a known folder
     GET  /order-mail/message?id=                                         open one (body as text, attachment names)
     POST /order-mail/file            {ref, messageIds}                    file into a SHOP order's folder
     POST /order-mail/file-to-folder  {folder, messageIds}                 file into a known vendor folder
   The same four routes an agent holding `ordermail.inbox.read` / `ordermail.message.read` /
   `ordermail.file` / `ordermail.file.folder` calls — one implementation, two callers, so a human
   can do by hand what the agent does, and can SEE what the agent saw (the three-surface rule:
   agent path, admin path, visible). Nothing here sends: there is no reply button on purpose.
   Self-contained on the dashboard-unlinked-emails.js pattern: bootstraps off window.RepPortal,
   reuses the shared modal classes, no dashboard-main.js wiring. */
(function () {
  'use strict';
  window.RQD = window.RQD || {};

  var FOLDERS = [
    { key: 'inbox', label: 'Inbox' },
    { key: 'vendors/ecore/samples', label: 'Vendors / ECORE / Samples' },
    { key: 'vendors/ecore/samples/processed', label: 'Vendors / ECORE / Samples / Processed by Abby' },
    { key: 'auto-replies', label: 'NEW Orders / Auto-replies' }
  ];
  var FILE_FOLDERS = FOLDERS.filter(function (f) { return f.key !== 'inbox'; });

  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function fmtWhen(s) {
    if (!s) return '';
    try { var d = new Date(s); if (isNaN(d.getTime())) return String(s).slice(0, 16); return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); }
    catch (e) { return String(s).slice(0, 16); }
  }
  var INPUT = 'padding:5px 8px;border:1px solid var(--rq-border);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg-input);color:var(--rq-text);';

  function ready(cb) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.RepPortal && window.RepPortal.Auth && window.RepPortal.API) {
        var sess = null;
        try { sess = window.RepPortal.Auth.getSession(); } catch (e) { /* */ }
        if (sess) { clearInterval(t); cb(sess); return; }
      }
      if (tries > 100) clearInterval(t);
    }, 200);
  }

  ready(function (sess) {
    var isAdmin = !!(sess && (sess.admin === true || sess.role === 'admin'));
    if (!isAdmin) return;
    injectButton(window.RepPortal.API);
  });

  function injectButton(API) {
    if (document.getElementById('rqd-ordersinbox-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'rqd-ordersinbox-btn';
    btn.className = 'rqd-pill';
    btn.style.cssText = 'white-space:nowrap;vertical-align:middle;';
    btn.textContent = 'orders@ Inbox';
    btn.title = 'Browse and search Abby’s shared orders@ mailbox, open a message, and file it into an order’s folder or a vendor folder — the same routes the AI agents use';
    btn.addEventListener('click', function () { openModal(API); });
    /* Beside the Unlinked emails pill when it is there (it injects itself after #rqd-new-wrap);
       otherwise straight after + New. Either way it is a quiet text link. */
    var after = document.getElementById('rqd-unlinked-btn') || document.getElementById('rqd-new-wrap');
    if (after && after.parentNode) {
      var sep = document.createElement('span');
      sep.className = 'rqd-sep';
      sep.textContent = '|';
      sep.setAttribute('aria-hidden', 'true');
      after.parentNode.insertBefore(sep, after.nextSibling);
      after.parentNode.insertBefore(btn, sep.nextSibling);
    } else {
      var bar = document.querySelector('.rqd-controls');
      if (!bar) return;
      bar.appendChild(btn);
    }
  }

  function openModal(API) {
    var prior = document.getElementById('rqd-ordersinbox-overlay');
    if (prior) prior.remove();
    var overlay = document.createElement('div');
    overlay.id = 'rqd-ordersinbox-overlay';
    overlay.className = 'rqd-daterange-backdrop';
    overlay.innerHTML = [
      '<div class="rqd-daterange-modal" style="max-width:860px;padding:22px 26px;max-height:88vh;display:flex;flex-direction:column;">',
      '  <h3 class="rqd-daterange-modal__title" style="margin-top:0;">orders@ Inbox</h3>',
      '  <div style="font-size:12px;color:var(--rq-text-secondary);margin-bottom:10px;">Abby’s shared mailbox, as the AI agents see it. Mail still in the Inbox is work not yet finished. Open a message to read it; file it once the work it asked for is done. Nothing here sends email.</div>',
      '  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap;">',
      '    <select id="rqd-oi-folder" style="' + INPUT + '">' + FOLDERS.map(function (f) { return '<option value="' + esc(f.key) + '">' + esc(f.label) + '</option>'; }).join('') + '</select>',
      '    <input type="text" id="rqd-oi-from" placeholder="from address" style="' + INPUT + 'width:180px;">',
      '    <input type="text" id="rqd-oi-subject" placeholder="subject contains (e.g. 6236, SHOP-2017)" style="' + INPUT + 'flex:1;min-width:180px;">',
      '    <input type="text" id="rqd-oi-since" value="14d" title="7d, 36h, or a date" style="' + INPUT + 'width:64px;text-align:center;">',
      '    <button type="button" id="rqd-oi-search" class="rqd-pill rqd-pill--active" style="font-size:11px;">Search</button>',
      '    <span id="rqd-oi-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>',
      '  </div>',
      '  <div id="rqd-oi-list" style="overflow-y:auto;flex:1;min-height:120px;">Press Search.</div>',
      '  <div class="rqd-daterange-modal__footer" style="margin-top:12px;">',
      '    <button type="button" id="rqd-oi-close" class="rqd-pill" style="margin-right:auto;">Close</button>',
      '  </div>',
      '</div>'
    ].join('\n');
    var mount = document.querySelector('.rep-quote-portal-wrap') || document.body;
    mount.appendChild(overlay);

    function close() { overlay.remove(); }
    overlay.querySelector('#rqd-oi-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, overlay)) close(); });

    var listEl = overlay.querySelector('#rqd-oi-list');
    var statusEl = overlay.querySelector('#rqd-oi-status');

    function rowHtml(m) {
      var refs = (m.subjectRefs || []).map(function (r) { return '<span class="rqd-pill" style="font-size:10px;padding:1px 6px;">' + esc(r) + '</span>'; }).join(' ');
      var who = (m.from && m.from.name ? esc(m.from.name) + ' ' : '') + '&lt;' + esc(m.from && m.from.address) + '&gt;';
      var firstRef = (m.subjectRefs || []).find(function (r) { return /^SHOP-/i.test(r); }) || '';
      return '<div class="rqd-oi-row" data-mid="' + esc(m.id) + '" style="border:1px solid var(--rq-border);border-radius:6px;padding:8px 10px;margin-bottom:8px;' + (m.isRead ? '' : 'border-left:3px solid #2563eb;') + '">'
        + '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline;">'
        + '<span style="font-weight:600;font-size:12px;">' + who + '</span>'
        + '<span style="font-size:11px;color:var(--rq-text-secondary);white-space:nowrap;">' + esc(fmtWhen(m.receivedAt)) + (m.hasAttachments ? ' 📎' : '') + '</span>'
        + '</div>'
        + '<div style="font-size:12px;margin:2px 0;">' + (m.subject ? esc(m.subject) : '<em style="color:var(--rq-text-secondary);">(no subject)</em>') + ' ' + refs + '</div>'
        + '<div class="rqd-oi-body" style="display:none;font-size:12px;white-space:pre-wrap;border:1px solid var(--rq-border);border-radius:4px;padding:8px 10px;margin:6px 0;background:var(--rq-bg-input);max-height:40vh;overflow-y:auto;"></div>'
        + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">'
        + '<button type="button" class="rqd-oi-open rqd-pill" style="font-size:11px;">Open</button>'
        + '<input type="text" class="rqd-oi-ref" value="' + esc(firstRef) + '" placeholder="SHOP-####" style="' + INPUT + 'width:110px;text-transform:uppercase;">'
        + '<button type="button" class="rqd-oi-file rqd-pill" style="font-size:11px;" title="Move it into that order’s folder under NEW Orders">File to order</button>'
        + '<select class="rqd-oi-folder-sel" style="' + INPUT + '"><option value="">File to folder…</option>' + FILE_FOLDERS.map(function (f) { return '<option value="' + esc(f.key) + '">' + esc(f.label) + '</option>'; }).join('') + '</select>'
        + '<span class="rqd-oi-row-status" style="font-size:11px;color:var(--rq-text-secondary);"></span>'
        + '</div>'
        + '</div>';
    }

    function search() {
      var folder = overlay.querySelector('#rqd-oi-folder').value;
      var q = { folder: folder, limit: 50 };
      var from = overlay.querySelector('#rqd-oi-from').value.trim();
      var subj = overlay.querySelector('#rqd-oi-subject').value.trim();
      var since = overlay.querySelector('#rqd-oi-since').value.trim();
      if (from) q.from = from;
      if (subj) q.subjectContains = subj;
      if (since) q.since = since;
      var qs = Object.keys(q).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(q[k]); }).join('&');
      listEl.textContent = 'Loading…';
      statusEl.textContent = '';
      API.get('/order-mail/inbox?' + qs).then(function (res) {
        if (!res || res.error) throw new Error((res && res.error) || 'Could not read the mailbox');
        if (res.connected === false) { listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:#dc2626;">orders@ is not connected.</div>'; return; }
        if (res.hasFolder === false) { listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:var(--rq-text-secondary);">That folder does not exist in orders@ yet (' + esc(res.why || '') + ').</div>'; return; }
        var items = res.messages || [];
        statusEl.textContent = items.length + (res.truncated ? '+' : '') + ' message' + (items.length === 1 ? '' : 's') + ' in ' + (res.folderLabel || folder);
        if (!items.length) { listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:var(--rq-text-secondary);">Nothing matched.</div>'; return; }
        listEl.innerHTML = items.map(rowHtml).join('');
      }).catch(function (err) {
        listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:#dc2626;">' + esc((err && err.message) || 'Search failed') + '</div>';
      });
    }
    overlay.querySelector('#rqd-oi-search').addEventListener('click', search);
    overlay.querySelector('#rqd-oi-subject').addEventListener('keydown', function (e) { if (e.key === 'Enter') search(); });
    overlay.querySelector('#rqd-oi-from').addEventListener('keydown', function (e) { if (e.key === 'Enter') search(); });

    function setStatus(el, text, ok) { el.style.color = ok === true ? '#15803d' : ok === false ? '#dc2626' : 'var(--rq-text-secondary)'; el.textContent = text; }

    listEl.addEventListener('click', function (e) {
      var row = e.target.closest('.rqd-oi-row');
      if (!row) return;
      var mid = row.getAttribute('data-mid');
      var st = row.querySelector('.rqd-oi-row-status');

      if (e.target.closest('.rqd-oi-open')) {
        var bodyEl = row.querySelector('.rqd-oi-body');
        if (bodyEl.style.display !== 'none') { bodyEl.style.display = 'none'; return; }
        setStatus(st, 'Opening…');
        API.get('/order-mail/message?id=' + encodeURIComponent(mid)).then(function (res) {
          if (!res || res.error) throw new Error((res && res.error) || 'Could not open it');
          var m = res.message || {};
          var head = 'To: ' + (m.to || []).join(', ') + (m.cc && m.cc.length ? '\nCc: ' + m.cc.join(', ') : '');
          var att = (m.attachments || []).length ? '\n\nAttachments: ' + m.attachments.map(function (a) { return a.name + ' (' + Math.round((a.size || 0) / 1024) + ' KB)'; }).join(', ') : '';
          var hints = [];
          if (m.vendorOrder) hints.push((m.vendorOrder.vendorLabel || m.vendorOrder.vendor) + ' order #' + m.vendorOrder.orderNumber + (m.vendorOrder.tracking && m.vendorOrder.tracking.length ? ' · ' + (m.vendorOrder.carrier || '') + ' ' + m.vendorOrder.tracking.join(', ') : ''));
          if (m.isEcoreSamplesMail) hints.push('ECORE samples desk');
          if (m.isAutoReply) hints.push('auto-reply');
          bodyEl.textContent = head + (hints.length ? '\n' + hints.join(' · ') : '') + '\n\n' + (m.body && m.body.text || '(empty)') + (m.body && m.body.truncated ? '\n… (truncated)' : '') + att;
          bodyEl.style.display = 'block';
          setStatus(st, res.file || '');
        }).catch(function (err) { setStatus(st, (err && err.message) || 'Could not open it', false); });
        return;
      }

      if (e.target.closest('.rqd-oi-file')) {
        var ref = String(row.querySelector('.rqd-oi-ref').value || '').trim().toUpperCase();
        if (!/^SHOP-\d+$/.test(ref)) { setStatus(st, 'Enter the SHOP-#### order to file it under.', false); return; }
        var fb = e.target.closest('.rqd-oi-file');
        fb.disabled = true; setStatus(st, 'Filing…');
        API.post('/order-mail/file', { ref: ref, messageIds: [mid] }).then(function (res) {
          if (!res || res.error) throw new Error((res && res.error) || 'File failed');
          if (res.filed && res.filed.length) { setStatus(st, '✓ filed under ' + ref, true); row.style.opacity = '0.5'; return; }
          var why = (res.skipped && res.skipped[0] && res.skipped[0].why) || (res.failed && res.failed[0] && res.failed[0].why) || 'not filed';
          setStatus(st, 'Not filed: ' + why + (why === 'no-shop-ref' || why === 'names-a-different-order' ? ' — the message must name ' + ref + ' or already sit on its feed' : ''), false);
          fb.disabled = false;
        }).catch(function (err) { fb.disabled = false; setStatus(st, (err && err.message) || 'File failed', false); });
        return;
      }
    });

    listEl.addEventListener('change', function (e) {
      var sel = e.target.closest('.rqd-oi-folder-sel');
      if (!sel || !sel.value) return;
      var row = e.target.closest('.rqd-oi-row');
      var mid = row.getAttribute('data-mid');
      var st = row.querySelector('.rqd-oi-row-status');
      var folder = sel.value;
      sel.disabled = true; setStatus(st, 'Filing…');
      API.post('/order-mail/file-to-folder', { folder: folder, messageIds: [mid] }).then(function (res) {
        if (!res || res.error) throw new Error((res && res.error) || 'File failed');
        if (res.filed && res.filed.length) { setStatus(st, '✓ moved to ' + (res.folderLabel || folder), true); row.style.opacity = '0.5'; return; }
        var why = (res.skipped && res.skipped[0] && res.skipped[0].why) || (res.failed && res.failed[0] && res.failed[0].why) || 'not moved';
        setStatus(st, 'Not moved: ' + why + (why === 'not-ecore-samples-mail' ? ' — that folder only takes the ECORE samples desk’s mail' : why === 'not-an-auto-reply' ? ' — that folder only takes out-of-office replies' : ''), false);
        sel.disabled = false; sel.value = '';
      }).catch(function (err) { sel.disabled = false; sel.value = ''; setStatus(st, (err && err.message) || 'File failed', false); });
    });

    search();
  }
})();
/* END CUSTOM_ORDERMAILINBOX_BY_CLAUDE */
